import { lensProp } from 'ramda'

export const selectedData = 'selectedData'
export const selectableData = 'selectableData'
export const lensSelectedData = lensProp('selectedData')
export const subGroupsKey = 'subGroups'
export const subscriberCountKey = 'subscribersCount'
export const allGroupSubscriberCountKey = 'allGroupsSubscribersCount'
export const groupsKey = 'groups'
export const mainGroupListKey = 'mainGroupList'
export const recepientType = 'recepientType'
export const isLoadingKey = 'isLoading'
export const errorKey = 'error'
export const saveSelectedGroupsState = 'saveSelectedGroupsState'

export const uiProps = 'uiProps'

export const domainListKey = 'list'
export const groupLabel = 'label'

//Special handler Everyone
export const everyoneSubGroupKey = 'everyoneSubGroupKey'
export const everyoneCount = 'everyoneCount'
